import peakABooHeader from "./peakABooHeader";
// toggle the submenu items in the mobile menu
const subMenuToggle = ($) => {
	$(".menu-item-has-children").on("click keydown", function (event) {
		if (event.type === "keydown" && event.key !== "Enter") {
			return;
		}
		$(".menu-item-has-children").not(this).removeClass("js-open-sub-menu");
		$(this).toggleClass("js-open-sub-menu");
	});

	peakABooHeader($);

};

export default subMenuToggle;
